import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { EditalCredenciamentoService } from '../edital-credenciamento.service';

@Component({
  templateUrl: './gerenciar-edital-credenciamento.component.html',
})
export class GerenciarEditalCredenciamentoComponent extends WebPage implements OnInit {

  editais;

  constructor(
    private confirmationService: ConfirmationService, messageService: MessageService,
    private editalCredenciamentoService: EditalCredenciamentoService,
    private arquivoService: ArquivoService
  ) {
    super(messageService);
  }

  ngOnInit() {
    const mensagem = localStorage.getItem('mensagem');
    if (mensagem != null && mensagem !== '') {
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: mensagem });
      localStorage.removeItem('mensagem');
    }

    this.isLoading = true;
    this.editalCredenciamentoService.getAllFull()
      .finally(() => this.isLoading = false)
      .subscribe(
        editais => this.editais = editais,
        error => this.gerenciaErro(error)
      );
  }

  publicarEdital(edital) {
    this.confirmationService.confirm({
      message: 'Deseja realmente publicar este edital?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        this.editalCredenciamentoService.publicar(edital.idEditalCredenciamento)
          .finally(() => this.isLoading = false)
          .subscribe(
            response => {
              const index = this.editais.indexOf(edital);
              this.editais[index].statusPublicacao.descricao = 'Publicado';
              this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Edital publicado com sucesso!' });
            },
            error => this.gerenciaErro(error)
          );
      }
    });
  }

  encerrarPublicacaoEdital(edital) {
    this.confirmationService.confirm({
      message: 'Deseja realmente encerrar a publicação deste edital?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        this.editalCredenciamentoService.encerrarPublicacao(edital.idEditalCredenciamento)
          .finally(() => this.isLoading = false)
          .subscribe(
            response => {
              const index = this.editais.indexOf(edital);
              this.editais[index].statusPublicacao.descricao = 'Encerrado';
              this.messageService.add({
                severity: 'warn',
                summary: 'Atenção',
                detail: 'Encerramento da publicação do edital realizada com sucesso!'
              });
            },
            error => this.gerenciaErro(error)
          );
      }
    });
  }

  downloadEdital(edital) {
    this.arquivoService.downloadArquivo(edital.arquivosMeio[0].idArquivo, 'Edital_Credenciamento');
  }

  excluirEdital(edital) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        this.editalCredenciamentoService.excluir(edital.idEditalCredenciamento)
          .finally(() => this.isLoading = false)
          .subscribe(
            response => {
              const index = this.editais.indexOf(edital);
              this.editais.splice(index, 1);
              this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'O Edital foi excluído.' });
            },
            error => this.gerenciaErro(error)
          );
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/editalCredenciamento/gerenciar-edital-credenciamento/gerenciar-edital-credenciamento.component.ts